<template>
	<modal body-classes="p-0" :show="open != null" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">แก้ไขโบนัส</h2>
			</template>
			<template>
				<form @submit.prevent="editBonus">
					<base-checkbox v-model="bonus.enable" class="mb-3">
						เปิดใช้งาน
					</base-checkbox>

					<base-input label="ชื่อโบนัส" placeholder="ชื่อโบนัส" required v-model="bonus.name" />
					<base-input label="รายละเอียด" placeholder="รายละเอียด" required v-model="bonus.description" />
					<base-input label="ประเภทโบนัส">
						<el-select v-model="bonus.category" placeholder="ประเภทโบนัส">
							<el-option label="โบนัสทั่วไป" value="deposit" />
							<el-option label="[UFA] คืนยอดเสียกีฬา" value="ufa-sport-wl-cashback" />
						</el-select>
					</base-input>

					<!-- limit -->
					<div class="bonusLimitSection" v-if="bonus.category === 'deposit'">
						<base-radio v-model="bonus.limit" name="newReg" required>
							สมัครสมาชิกใหม่
						</base-radio>
						<base-radio v-model="bonus.limit" name="dailyFirstDeposit" required>
							ฝากครั้งแรกของวัน
						</base-radio>
						<base-radio v-model="bonus.limit" name="allDeposit" required>
							ทุกรายการฝาก
						</base-radio>
						<base-radio v-model="bonus.limit" name="once" required>
							ครั้งเดียว
						</base-radio>
					</div>
					<div class="my-1" v-else-if="bonus.category === 'ufa-sport-wl-cashback'">
						<base-radio v-model="bonus.limit" name="every-day" class="mb-2" required>
							รับได้ทุกวัน
						</base-radio>
						<base-radio v-model="bonus.limit" name="every-week" class="mb-3" required>
							รับได้ทุกสัปดาห์
						</base-radio>
					</div>

					<!-- amount & type -->
					<div class="row">
						<div class="col-6">
							<base-input label="โบนัส" placeholder="โบนัส" required v-model.number="bonus.amount" />
						</div>
						<div class="col-6">
							<base-input label="ประเภท">
								<el-select v-model="bonus.type" placeholder="ประเภท">
									<el-option label="เปอร์เซ็นต์" value="percent" />
									<el-option label="จำนวน" value="amount" />
								</el-select>
							</base-input>
						</div>
					</div>

					<!-- min & max -->
					<div class="row">
						<div class="col-6">
							<base-input
								label="โบนัสขั้นต่ำ"
								placeholder="โบนัสขั้นต่ำ"
								required
								v-model.number="bonus.minBonus"
							/>
						</div>
						<div class="col-6">
							<base-input
								label="โบนัสสูงสุด"
								placeholder="โบนัสสูงสุด"
								required
								v-model.number="bonus.maxBonus"
							/>
						</div>
					</div>

					<!-- min deposit & turn -->
					<div class="row">
						<div class="col-6">
							<base-input
								label="ยอดฝากขั้นต่ำ"
								placeholder="ยอดฝากขั้นต่ำ"
								required
								v-model.number="bonus.minimum"
							/>
						</div>
						<div class="col-6">
							<base-input label="เทิร์น" placeholder="เทิร์น" required v-model.number="bonus.turn" />
						</div>
					</div>

					<!-- game type -->
					<div class="row">
						<div class="col-6">
							<base-input label="ประเภท (เกม)">
								<el-select v-model="bonus.gameType" placeholder="ประเภท (เกม)">
									<el-option label="ไม่ระบุ" value="" />
									<el-option label="คาสิโน" value="casino" />
									<el-option label="สล็อต" value="slot" />
								</el-select>
							</base-input>
						</div>
						<div class="col-6">
							<base-input label="ลำดับ" placeholder="ลำดับ" required v-model.number="bonus.order" />
						</div>
					</div>

					<!-- max withdraw -->
					<div class="row">
						<div class="col-6">
							<base-input label="ประเภทถอนสูงสุด">
								<el-select v-model="bonus.withdrawLimitType" placeholder="ประเภทถอนสูงสุด">
									<el-option label="จำนวน" value="fixed" />
									<el-option label="ยอดโบนัส (เท่า)" value="sum" />
								</el-select>
							</base-input>
						</div>
						<div class="col-6">
							<base-input
								label="จำนวนถอนสูงสุด"
								placeholder="จำนวนถอนสูงสุด"
								v-model.number="bonus.withdrawLimit"
								v-if="bonus.withdrawLimitType == 'fixed'"
							/>
							<base-input
								label="ถอนสูงสุด (เท่า)"
								placeholder="ถอนสูงสุด (เท่า)"
								v-model.number="bonus.withdrawLimit"
								v-else
							/>
						</div>
					</div>

					<!-- steps -->
					<div class="bonus-cb-section">
						<div class="bonus-cb-title">
							<base-checkbox v-model="stepBonus">
								โบนัสแบบเงื่อนไข
							</base-checkbox>

							<div v-if="stepBonus">
								<base-button type="primary" size="sm" @click="addMoreStep">
									<i class="fa fa-plus" />
								</base-button>
								<base-button type="danger" size="sm" @click="deleteLastStep">
									<i class="fa fa-trash" />
								</base-button>
							</div>
						</div>

						<div class="bonus-cb-content" v-if="stepBonus">
							<div class="row" v-for="(step, k) in steps" :key="`step${k}`">
								<div class="col-4">
									<base-input
										label="ยอดฝากจาก"
										placeholder="ยอดฝากจาก"
										required
										v-model.number="step.min"
									/>
								</div>
								<div class="col-4">
									<base-input label="ถึง" placeholder="ถึง" required v-model.number="step.max" />
								</div>
								<div class="col-4">
									<base-input
										label="โบนัส"
										placeholder="โบนัส"
										required
										v-model.number="step.bonus"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- periods -->
					<div class="bonus-cb-section">
						<div class="bonus-cb-title">
							<base-checkbox v-model="periodBonus">
								โบนัสตามช่วงเวลา
							</base-checkbox>

							<div v-if="periodBonus">
								<base-button type="primary" size="sm" @click="addMorePeriod">
									<i class="fa fa-plus" />
								</base-button>
								<base-button type="danger" size="sm" @click="deleteLastPeriod">
									<i class="fa fa-trash" />
								</base-button>
							</div>
						</div>

						<div class="bonus-cb-content" v-if="periodBonus">
							<div class="row" v-for="(p, k) in periods" :key="`period${k}`">
								<div class="col-6">
									<base-input
										label="จาก"
										placeholder="จาก"
										required
										v-mask="'##:##'"
										v-model="p.from"
									/>
								</div>
								<div class="col-6">
									<base-input
										label="ถึง"
										placeholder="ถึง"
										required
										v-mask="'##:##'"
										v-model="p.to"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- consecutive deposit -->
					<div class="bonus-cb-section">
						<div class="bonus-cb-title">
							<base-checkbox v-model="consecutiveDepositBonus.enable">
								โบนัสฝากติดต่อกัน
							</base-checkbox>
						</div>

						<div class="bonus-cb-content" v-if="consecutiveDepositBonus.enable">
							<div class="row">
								<div class="col-6">
									<base-input
										type="number"
										label="ฝากติดต่อกัน (วัน)"
										placeholder="ฝากติดต่อกัน (วัน)"
										required
										v-model.number="consecutiveDepositBonus.consecutiveDepositDays"
									/>
								</div>
								<div class="col-6">
									<base-input
										type="number"
										label="ยอดฝากขั้นต่ำต่อวัน"
										placeholder="ยอดฝากขั้นต่ำต่อวัน"
										required
										v-model.number="consecutiveDepositBonus.minimumDepositPerDay"
									/>
								</div>
							</div>

							<base-checkbox v-model="consecutiveDepositBonus.rules.noWithdraw">
								ไม่มีรายการถอน
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noBonus">
								ไม่มีรายการรับโบนัส
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noCashback">
								ไม่มีรายการรับแคชแบ็ก
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noLuckyWheel">
								ไม่มีรายการหมุนกงล้อเสี่ยงโชค
							</base-checkbox>
						</div>
					</div>

					<div class="bonus-cb-section">
						<div class="bonus-cb-title">
							<base-checkbox v-model="noDepositBetween.enable">
								ไม่มียอดฝาก
							</base-checkbox>
						</div>

						<div class="bonus-cb-content" v-if="noDepositBetween.enable">
							<div class="row">
								<div class="col-6">
									<base-input label="จาก">
										<flat-picker
											class="form-control datepicker"
											v-model="noDepositBetween.startDate"
										/>
									</base-input>
								</div>
								<div class="col-6">
									<base-input label="ถึง">
										<flat-picker
											class="form-control datepicker"
											v-model="noDepositBetween.endDate"
										/>
									</base-input>
								</div>
							</div>

							<base-checkbox v-model="consecutiveDepositBonus.rules.noWithdraw">
								ไม่มีรายการถอน
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noBonus">
								ไม่มีรายการรับโบนัส
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noCashback">
								ไม่มีรายการรับแคชแบ็ก
							</base-checkbox>
							<base-checkbox v-model="consecutiveDepositBonus.rules.noLuckyWheel">
								ไม่มีรายการหมุนกงล้อเสี่ยงโชค
							</base-checkbox>
						</div>
					</div>

					<!-- image -->
					<div class="bonus-image-section">
						<upload
							label="รูปภาพ"
							setting="promotion"
							:params="{ key: bonus.key }"
							@uploaded="uploaded"
							v-if="!bonus.image"
						/>

						<div v-else>
							<img :src="bonus.image" width="200px" alt="bonus" />

							<base-button
								type="danger"
								size="sm"
								class="d-block mt-2"
								@click="deleteBonusImage(bonus.key)"
							>
								ลบรูปภาพ
							</base-button>
						</div>
					</div>

					<base-button native-type="submit" type="default" :disabled="loading">
						บันทึกข้อมูล
					</base-button>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'
import Upload from '../../backend-components/Common/Upload'
import flatPicker from 'vue-flatpickr-component'
import moment from 'moment'

import BonusService from '../../services/bonus.service'

export default {
	props: ['open'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		Upload,
		flatPicker,
	},
	data() {
		return {
			loading: false,

			bonus: {},
			steps: [],
			stepBonus: false,

			periods: [],
			periodBonus: false,

			consecutiveDepositBonus: {
				enable: false,
				consecutiveDepositDays: 3,
				minimumDepositPerDay: 1,
				rules: {},
			},
			noDepositBetween: {
				enable: false,
				startDate: moment().format('YYYY-MM-DD'),
				endDate: moment().format('YYYY-MM-DD'),
				rules: {},
			},
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		uploaded() {
			this.$emit('close')
			this.$emit('reload')
		},
		async editBonus() {
			try {
				this.loading = true

				const data = Object.assign({}, this.bonus, {
					step: this.stepBonus,
					steps: this.steps,
					period: this.periodBonus,
					periods: this.periods,

					consecutiveDepositBonus: this.consecutiveDepositBonus,
					noDepositBetween: this.noDepositBetween,
				})
				const res = await BonusService.editBonus(data)
				this.$notify({ type: 'success', message: res.message })

				this.$emit('close')
				this.$emit('reload')
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
		async deleteBonusImage(key) {
			try {
				const res = await BonusService.deleteBonusImage(key)
				this.$notify({ type: 'success', message: res.message })

				this.$emit('close')
				this.$emit('reload')
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			}
		},
		addMoreStep() {
			this.steps.push({ min: 0, max: 0, bonus: 0 })
		},
		deleteLastStep() {
			this.steps.pop()
		},
		addMorePeriod() {
			this.periods.push({ from: '00:00', to: '00:00' })
		},
		deleteLastPeriod() {
			this.periods.pop()
		},
	},
	watch: {
		open(v) {
			this.bonus = Object.assign({}, v)

			if (!this.bonus.step) {
				this.steps = [{ min: 0, max: 0, bonus: 0 }]
			} else {
				this.steps = this.bonus.steps
				this.stepBonus = true
			}

			if (!this.bonus.period) {
				this.periods = [{ from: '00:00', to: '23:59' }]
			} else {
				this.periods = this.bonus.periods
				this.periodBonus = true
			}

			if (this.bonus.consecutiveDepositBonus) {
				this.consecutiveDepositBonus = this.bonus.consecutiveDepositBonus
				if (!this.consecutiveDepositBonus.rules) {
					this.consecutiveDepositBonus.rules = {}
				}
			}
			if (this.bonus.noDepositBetween) {
				this.noDepositBetween = this.bonus.noDepositBetween
				if (!this.noDepositBetween.rules) {
					this.noDepositBetween.rules = {}
				}
			}
		},
	},
}
</script>
